module.exports = __webpack_public_path__ + "static/8-f945a2dfccda65f8ea65b30f826b9b7f.jpg";